module.exports = __webpack_public_path__ + "9f58ed607aa5129140053f94f0ccb8ae.fbx";